import { tv } from 'tailwind-variants';

export const tooltipStyles = tv({
  slots: {
    arrow: 'fill-foreground',
    content:
      'data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=delayed-open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 rounded-md outline-none',
    trigger: 'cursor-help',
  },
  variants: {
    design: {
      default: {
        arrow: 'fill-secondary-light-one',
        content:
          'bg-secondary-light-three border border-secondary-light-one text-secondary shadow-sm',
        trigger: 'text-secondary',
      },
      error: {
        arrow: 'fill-destructive/10',
        content:
          'border border-destructive bg-destructive/10 text-destructive shadow-sm',
        trigger: '',
      },
      info: {
        arrow: 'fill-primary',
        content: 'bg-primary text-primary-foreground shadow-sm',
        trigger: '',
      },
      warning: {
        arrow: 'fill-amber-50',
        content: 'border border-amber-400 bg-amber-50 text-amber-900 shadow-sm',
        trigger: '',
      },
    },
    size: {
      lg: {
        content: 'max-w-md px-4 py-3 text-sm',
      },
      md: {
        content: 'max-w-sm px-4 py-3 text-sm',
      },
      sm: {
        content: 'max-w-xs px-2 py-1 text-xs',
      },
    },
  },
  defaultVariants: {
    design: 'default',
    size: 'md',
  },
});
